import { useParams } from 'react-router-dom';

import ServiceListView from './ServiceListView';

export default function ContextListView() {
	const { id: subDomainId } = useParams<{ id: string }>();

	return <ServiceListView initialSubDomainId={subDomainId} />;
}
